import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import { useSegment } from '../../hooks';
import { types } from './definitions';

const ReactHelmet = ({
  content,
  title,
  noindex = false,
}: types.ReactHelmetProps): JSX.Element => {
  const { trackPage } = useSegment();

  // Calling trackPage in useEffect here ensures that:
  //  - The component has mounted
  //  - The page title is updated before we send the event
  //  - We only send the event once
  useEffect(() => {
    trackPage();
  }, []);

  const meta = [
    { name: 'description', content: content },
    { name: 'og:title', content: title },
    { name: 'og:type', content: 'website' },
    { name: 'og:image', content: `${window.location.href}/logo512.png` },
    { name: 'og:url', content: window.location.href },
    { name: 'og:site_name', content: 'Twilio Help Center' },
    { name: 'og:description', content: content },
  ];
  const link = [{ rel: 'canonical', href: window.location.href }];

  // Set the document title considering that Helmet will not update the
  // document title in time for the trackPage method to send the correct title
  if (title) {
    document.title = title;
  }

  // This meta tag will prevent search engines from indexing the page
  if (noindex) {
    meta.push({ name: 'robots', content: 'noindex,nofollow' });
  }

  return <Helmet prioritizeSeoTags title={title} meta={meta} link={link} />;
};

export default ReactHelmet;
